import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

function CGU() {
  return (
    <div>
      <Nav />
      <div className='wrapper-container legal-container'>
        <div className='wrapper-content'>

          <div className='title-wrapper'>
            <h2>Conditions Générales d’Utilisation</h2>
          </div>

          <p>
            Les présentes CGU encadrent l’utilisation de la plateforme Fastline.
          </p>

          <br />

          <h2><strong>1. Objet</strong></h2>
          <p>
            Fastline permet à des professionnels (vendeurs, commerçants, restaurateurs ou prestataires)
            de proposer leurs produits ou services en ligne.
          </p>
          <p>
            Les clients peuvent commander et payer directement via la plateforme.
          </p>
          <p>
            Fastline agit exclusivement comme intermédiaire technique.
          </p>

          <br />

          <h2><strong>2. Accès au service</strong></h2>
          <p>
            L’accès à Fastline est gratuit. Certaines fonctionnalités nécessitent la création d’un compte.
          </p>

          <br />

          <h2><strong>3. Compte utilisateur</strong></h2>
          <p>
            L’utilisateur est responsable des informations fournies et de la sécurité de son compte.
          </p>

          <br />

          <h2><strong>4. Rôle de Fastline</strong></h2>
          <p>
            Fastline fournit uniquement un service technique de mise en relation et de gestion des paiements.
          </p>
          <p>
            Fastline n’est pas vendeur des produits ou services proposés.
          </p>
          <p>
            Le contrat de vente est conclu directement entre le client et le vendeur.
          </p>

          <br />

          <h2><strong>5. Responsabilités</strong></h2>
          <p>
            Les vendeurs sont seuls responsables :
          </p>
          <ul>
            <li>des produits ou services</li>
            <li>des prix</li>
            <li>des commandes</li>
            <li>de la livraison</li>
          </ul>
          <p>
            Fastline ne peut être tenu responsable des litiges entre clients et vendeurs.
          </p>

          <br />

          <h2><strong>6. Paiements</strong></h2>
          <p>
            Les paiements sont sécurisés via Stripe.
          </p>
          <p>
            Fastline agit comme intermédiaire technique dans le traitement des paiements.
          </p>
          <p>
            <strong>Contestations de paiement et remboursements.</strong> Lorsqu’un client
            conteste un paiement auprès de sa banque (litige ou « chargeback »), ou
            lorsqu’une commande est remboursée, le montant concerné ainsi que les frais
            de litige facturés par Stripe sont à la charge du vendeur à l’origine de la
            vente.
          </p>
          <p>
            Le vendeur autorise Fastline à récupérer ces montants, selon le cas : par
            annulation du virement correspondant sur son compte Stripe, par déduction
            sur ses ventes suivantes, ou par prélèvement sur son solde Stripe. Si ces
            moyens ne suffisent pas, le vendeur s’engage à régler la somme due à
            Fastline dans un délai de 15 jours après demande.
          </p>
          <p>
            Le vendeur s’engage à fournir, à la demande de Fastline et dans les délais
            indiqués, tout justificatif utile pour contester un litige (preuve de
            livraison ou de remise, échanges avec le client, facture). À défaut, le
            litige pourra être perdu et restera à sa charge.
          </p>

          <br />

          <h2><strong>7. Utilisation</strong></h2>
          <p>
            L’utilisateur s’engage à utiliser la plateforme de manière conforme à la loi.
          </p>

          <br />

          <h2><strong>8. Suspension</strong></h2>
          <p>
            Fastline peut suspendre un compte en cas de non-respect des CGU.
          </p>

          <br />

          <h2><strong>9. Données personnelles</strong></h2>
          <p>
            Les données sont traitées conformément à la{' '}
            <Link to="/privacy" style={{textDecoration:'underline'}}>Politique de confidentialité</Link>.
          </p>

          <br />

          <h2><strong>10. Droit applicable</strong></h2>
          <p>
            Les présentes CGU sont soumises au droit français.
          </p>

        </div>
      </div>
    </div>
  );
}

export default CGU;